import { useTranslation } from "react-i18next";
import { PopupDisclosureList } from "../SearchForm/DisclosuresDropdownMenu";

const SearchTopBar = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className="text-base text-stone-vibrant font-medium-light">
                {t("searchForm.searchPartialInMsg")}
            </div>

            <PopupDisclosureList  />
        </>
    );
}

export default SearchTopBar;
